import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { FlashProvider } from "./components/flash";
import { FaceGoI18nProvider } from "./design-system/i18n";
import { applyFaceGoTheme, readStoredMode } from "./design-system/theme";
import { installAnalytics } from "./lib/analytics";
import "@cloudscape-design/global-styles/index.css";
import "./design-system/fonts.css";
import "./design-system/brand.generated.css";

applyFaceGoTheme(readStoredMode());
installAnalytics();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Không tự thử lại lỗi 401: token hỏng thì phải đưa người dùng về đăng nhập.
      retry: (failureCount, error) =>
        failureCount < 2 && !(error instanceof Error && "status" in error && error.status === 401),
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("Không tìm thấy phần tử #root");

createRoot(container).render(
  <StrictMode>
    <FaceGoI18nProvider>
      <QueryClientProvider client={queryClient}>
        <FlashProvider>
          <ErrorBoundary level="page">
            <App />
          </ErrorBoundary>
        </FlashProvider>
      </QueryClientProvider>
    </FaceGoI18nProvider>
  </StrictMode>,
);
